export class WebApiDto {
  url: string;
  cloudType: string;
}
